export default "__VITE_ASSET__lpFYSvKR__"